export default function getYearByMonths(year) {
    return ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto',
    'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
}

